module.exports = "/assets/data/feb7f084efb62d7fb9761da45631c22d-CV2.data.json";